var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 503.71 503.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#434864",
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 251.85,
    cy: 251.85,
    r: 251.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_18",
    "data-name": "Union 18",
    fill: "#fff",
    d: "M254.37,429.24a8.79,8.79,0,0,1-6.3-4.18L161.16,285.57a106,106,0,0,1-16.66-57.21,111.11,111.11,0,0,1,222.18,0,106,106,0,0,1-15.74,55.7L263.76,424.83a8.94,8.94,0,0,1-2.9,3,9.54,9.54,0,0,1-6.55,1.36ZM200.05,228.36a55,55,0,0,0,55.38,54.5h.16a54.5,54.5,0,1,0-55.54-54.5Z",
    transform: "translate(-4.65 -3.15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/iconMap.4a4ebd8cdccb98112001ed1870d3f500.svg";
export { ForwardRef as ReactComponent };